import { addMonths, setMonthDateWithoutOverflow, subtractMonths } from '../../shared/helpers/abacusTimeFormatter';
import { AMEX_BILLING_STRIPE_PLAN_TYPE } from '../constants';
export function checkIfBillingPlanIsAmex(billingPlan) {
    return [AMEX_BILLING_STRIPE_PLAN_TYPE.FREE_PLAN, AMEX_BILLING_STRIPE_PLAN_TYPE.PRO_PLAN].includes(billingPlan);
}
export function getLatestAndNextBillingDates(company) {
    let latestBillingDate, nextBillingDate;
    const currentMonth = new Date().getMonth();
    const prevMonth = subtractMonths(new Date(), 1).getMonth();
    const nextMonth = addMonths(new Date(), 1).getMonth();
    const billingDay = company.billing_day;
    if (new Date().getDate() > billingDay) {
        latestBillingDate = setMonthDateWithoutOverflow(new Date(new Date().getFullYear(), currentMonth), billingDay);
        nextBillingDate = setMonthDateWithoutOverflow(new Date(new Date().getFullYear(), nextMonth), billingDay);
    }
    else {
        latestBillingDate = setMonthDateWithoutOverflow(new Date(new Date().getFullYear(), prevMonth), billingDay);
        nextBillingDate = setMonthDateWithoutOverflow(new Date(new Date().getFullYear(), currentMonth), billingDay);
    }
    return { latestBillingDate, nextBillingDate };
}
export function getMileageRateFromConfig(mileage_rate_per_year, expenseDate) {
    const year = expenseDate ? new Date(expenseDate).getFullYear() : new Date().getFullYear();
    if (mileage_rate_per_year.hasOwnProperty('custom')) {
        return mileage_rate_per_year.custom;
    }
    const mileageRate = mileage_rate_per_year.find((rate) => rate.year === year);
    if (mileageRate) {
        return mileageRate.rate;
    }
    const latestYearRate = mileage_rate_per_year.reduce((latest, current) => {
        return current.year > latest.year ? current : latest;
    }, mileage_rate_per_year[0]);
    return latestYearRate.rate;
}
